import React from 'react';
import PropTypes from 'prop-types';

import { routes } from '../../../routes';

const propTypes = {
  user: PropTypes.object,
};

const CanvasSettings = ({ user }) => (
  <div>
    <h2>Canvas Settings</h2>
    <div className="form-group row">
      <p className="col-md-10">
        In order to allow MySage Financial Solutions to create new accounts in Canvas on your behalf, you must link your administrator
        Canvas account to your MySage Financial Solutions account.
      </p>
      <p className="col-md-3">Account status:</p>
      <p className="col-md-7">{user.canvasToken ? 'Linked' : 'Unlinked'}</p>
    </div>
    <hr />
    <div className="form-group row row mb-0">
      <div className="col-md-6 offset-md-4 text-right">
        {!user.canvasToken ? (
          <a href={routes.oauthCanvas} className="btn btn-primary">
            Link Canvas Account
          </a>
        ) : (
          <a href={routes.oauthCanvasLogout} className="btn btn-danger">
            Unlink Canvas Account
          </a>
        )}
      </div>
    </div>
  </div>
);

CanvasSettings.propTypes = propTypes;

export default CanvasSettings;
